import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useMemo } from 'react';
import BaseViewer from './Base';
import { useSafeUrlHandler } from '../../SafeUrlModal/hooks/useSafeUrlHandler';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/deviation.scss';
const DeviationViewer = (_param)=>{
    var { theme: themeFromProps, fixedParagraph = true } = _param, restProps = _object_without_properties(_param, [
        "theme",
        "fixedParagraph"
    ]);
    const theme = useMemo(()=>mergeTheme(baseTheme, themeFromProps), [
        themeFromProps
    ]);
    const handler = useSafeUrlHandler();
    return /*#__PURE__*/ React.createElement("div", {
        className: 'da-editor-deviation',
        onClickCapture: handler
    }, /*#__PURE__*/ React.createElement(BaseViewer, _object_spread({
        theme: theme,
        fixedParagraph: fixedParagraph
    }, restProps)));
};
DeviationViewer.displayName = 'JournalViewer';
export default DeviationViewer;
